import { useMutation } from '@tanstack/react-query';

export default function useUpdateOrganizationStaff() {
  const token = (document.getElementsByName('csrf-token')[0] as HTMLMetaElement).content;
  return useMutation({
    mutationFn: async (params: { id: number; name: string; email: string; is_admin: boolean }) => {
      const response = await fetch(`/agent/api/organization_users/${params.id}`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-CSRF-Token': token,
        },
        body: JSON.stringify({
          name: params.name,
          email: params.email,
          is_admin: params.is_admin,
        }),
      });
      if (!response.ok) {
        throw new Error('Failed to update organization staff');
      }
      return await response.json();
    },
  });
}
